export const kE = 1;
export const kCH = 1;
export const θ = (26 / 180) * Math.PI;
export const cosθ = Math.cos(θ);
export const sinθ = Math.sin(θ);
export const factor = 100 / Math.log(139 / 100); // ~ 303.67
